module.exports = __webpack_public_path__ + "static/media/apple-launch-img.a5a3e659.png";